import { jwtDecode } from "jwt-decode"
import { LocalStorage } from "../storage/LocalStorage"

type AuthCredentialsResponse = {
  access_token: string
}

export enum StorageKeys {
  AccessToken = 'accessToken',
}

export class AuthStorage {
  static setAuthCredentials({ access_token }: AuthCredentialsResponse) {
    AuthStorage.setAccessToken(access_token)
  }

  static setAccessToken(token: string) {
    LocalStorage.setItem(StorageKeys.AccessToken, token)
  }

  static getAccessToken() {
    try {
      const item = LocalStorage.getItem(StorageKeys.AccessToken)
      return item
    } catch (err) {
      return ''
    }
  }

  static isTokenValid() {
    try {
      const token = this.getAccessToken()
      if (!token) {
        return false
      }

      const decodedToken = jwtDecode<{ exp: number }>(token)
      const currentTime = Date.now() / 1000
      
      // Verifica se o token não expirou
      return decodedToken.exp > currentTime
    } catch (err) {
      // Se não conseguir decodificar o token, considera inválido
      return false
    }
  }

  static clearAccessToken() {
    LocalStorage.removeItem(StorageKeys.AccessToken)
  }

  static logout() {
    this.clearAccessToken()
    // Redireciona para login, substituindo o histórico para evitar voltar com "back"
    window.location.replace('/login')
  }

  static getUser = () => {
    const token = this.getAccessToken()
    const decodedToken = jwtDecode<{
      user: {
        id: string
        login: string
        role: string
        state: string
      }
    }>(token)

    return decodedToken.user
  }
}